import Loader from '@betterfunnel/ui-core/Loader';
import * as Sentry from '@sentry/react';
import { RefObject, useContext, useEffect, useMemo, useState } from 'react';
import { DashboardContext } from '../contexts/DashboardContext';
import { DynamicPageContext } from '../contexts/DynamicPageContext';
import { UserContext } from '../contexts/UserContext';
import { buildPreviewUrl } from '../utils';

interface Props {
  websiteId: string;
  editable?: boolean;
  id?: string;
  iframeRef?: RefObject<HTMLIFrameElement | null>;
}

export const WebsitePreview = ({
  websiteId,
  editable,
  id,
  iframeRef,
}: Props) => {
  const { selectedAccount } = useContext(UserContext);
  const { selectedDynamicPage } = useContext(DashboardContext);
  const {
    dynamicPageWebsitePreviewToken,
    fetchDynamicPageWebsitePreviewToken,
    primaryDomain,
  } = useContext(DynamicPageContext);

  const [websitePreviewTokenError, setWebsitePreviewTokenError] = useState();

  const initialUrl = useMemo(
    () =>
      websiteId &&
      selectedAccount &&
      selectedDynamicPage &&
      primaryDomain &&
      dynamicPageWebsitePreviewToken
        ? buildPreviewUrl(
            primaryDomain.data().domain,
            selectedAccount.id,
            selectedDynamicPage.id,
            websiteId,
            dynamicPageWebsitePreviewToken,
            editable || false,
          )
        : null,
    [
      websiteId,
      selectedAccount,
      selectedDynamicPage,
      primaryDomain,
      dynamicPageWebsitePreviewToken,
      editable,
    ],
  );

  useEffect(() => {
    if (dynamicPageWebsitePreviewToken) return;
    if (websitePreviewTokenError) return;
    if (!websiteId || !selectedAccount) return;

    fetchDynamicPageWebsitePreviewToken().catch((e) => {
      Sentry.captureException(e);
      setWebsitePreviewTokenError(e);
    });
  }, [
    dynamicPageWebsitePreviewToken,
    websitePreviewTokenError,
    websiteId,
    selectedAccount,
    fetchDynamicPageWebsitePreviewToken,
  ]);

  return (
    <>
      {initialUrl ? (
        <iframe
          id={id}
          ref={iframeRef}
          className="iframe-website-preview"
          data-website-id={websiteId}
          style={{
            height: '100%',
            width: '100%',
            border: 0,
            minHeight: 0,
            minWidth: 0,
            backgroundColor: 'white',
          }}
          src={initialUrl}
        ></iframe>
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',
          }}
        >
          <Loader />
        </div>
      )}
    </>
  );
};
